import { Area, AreaChart, CartesianGrid, Legend, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { money } from "@/lib/api";

const short = (n) => (n >= 1000 ? `$${Math.round(n / 1000)}k` : `$${Math.round(n)}`);

export const CalcChart = ({ price, lbs, pcts: [lo, hi] }) => {
  const range = lo !== hi;
  const data = Array.from({ length: 50 }, (_, i) => {
    const l = i + 1;
    return { lbs: l, now: l * price, usMin: l * price * (1 - lo / 100), usMax: l * price * (1 - hi / 100) };
  });
  return (
    <div className="h-72 sm:h-80 text-muted-foreground" data-testid="calculator-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="currentColor" strokeOpacity={0.15} />
          <XAxis dataKey="lbs" tick={{ fill: "currentColor", fontSize: 12 }} tickLine={false} />
          <YAxis tickFormatter={short} tick={{ fill: "currentColor", fontSize: 12 }} tickLine={false} axisLine={false} width={48} />
          <Tooltip formatter={(v) => money(v)} labelFormatter={(l) => `${l} lbs`} contentStyle={{ borderRadius: 12, background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", color: "hsl(var(--foreground))" }} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <ReferenceLine x={lbs} stroke="#f59e0b" strokeDasharray="4 4" />
          <Area type="monotone" dataKey="now" name="Paying now" stroke="#f59e0b" fill="#f59e0b" fillOpacity={0.15} strokeWidth={2} isAnimationActive />
          <Area type="monotone" dataKey="usMin" name={range ? `Through us at ${lo}% off` : "Through I'm The Plug Now"} stroke="#10b981" fill="#10b981" fillOpacity={0.3} strokeWidth={2} />
          {range && <Area type="monotone" dataKey="usMax" name={`Through us at ${hi}% off`} stroke="#a855f7" fill="#a855f7" fillOpacity={0.3} strokeWidth={2} />}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
